import type { FC, ReactElement } from 'react';
import { useDispatch } from 'react-redux';

import { URL_ROUTES } from '@/constants';
import { setLeavingPayment } from '@/modules/perseo-billing/store/slices/billing';

const message =
  'Por razones de seguridad, para comprar con Gift Card tendrás que iniciar sesión o crear una cuenta. Por favor, vuelve al paso ';
const messageLinkLabel = 'Datos';
const messageEnd = ' para hacerlo.';

export const GiftCardAuthenticationMessage: FC = (): ReactElement => {
  const dispath = useDispatch();

  const handlerClick = () => {
    const baseUrl = window.location.origin;
    const redirectUrl = `${baseUrl}${URL_ROUTES.PERSONAL_DETAILS}`;
    dispath(setLeavingPayment(redirectUrl));
  };
  return (
    <p className="co-font-medium co-text-h4 co-leading-24px co-text-pds-neutral-600">
      {message}
      <span
        onClick={handlerClick}
        className="co-text-h4 co-font-normal co-text-pds-primary-600 co-cursor-pointer"
      >
        {messageLinkLabel}
      </span>
      {messageEnd}
    </p>
  );
};
